/** @module Enums */ /** typedoc */

export enum ReleaseGlobalStateEnum {
    Released = 'Released',
    Draft = 'Draft',
    InProgress = 'InProgress',
    TakenDown = 'TakenDown',
    Paused = 'Paused'
}
